import React from 'react';
import Button from 'screens/components/basic/Button';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import TextInput from 'screens/components/basic/TextInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SelectInput from 'screens/components/basic/SelectInput';
import CardSimple from 'screens/components/basic/CardSimple';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';

const componentName = "PurchaseOrderReceiver";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row m-0">
            <div className="col-xs-6 col-sm-6 col-md-4">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label}
                    hintText={LOOKUP.report.common.beginDate.label}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-4">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label}
                    hintText={LOOKUP.report.common.endDate.label}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <td className="col-xs-12 col-sm-12 col-md-4">
                <SelectInput
                    name={componentName + "Province"}
                    fullWidth
                    defaultValue="All"
                    label="Province"
                    floatingLabelText="Province"
                    options={props.provinceOptions}
                />
            </td>
            <div className="col-xs-12 col-sm-12 col-md-4">
                <BranchMultiSelectAutoCompleteInput
                    defaultValues={localStorage.getItem("PurchaseOrderReceiverBranchIds") != null ? localStorage.getItem("PurchaseOrderReceiverBranchIds").split(",").map(item => { return ({ value: item }) }) : props.branchOptions.map(item => { return ({ value: item.value }) })}
                    name={componentName + 'BranchIds'}
                    label="Branches"
                    floatingLabelText="Branches"
                    hintText="Branches"
                    provinceFilter={props.selectedProvince}
                />
            </div>
            <div className="row">
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-4">
                <TextInput
                    name={componentName + "SKU"}
                    floatingLabelText={"SKU"}
                    hintText={"SKU"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-4">
                <TextInput
                    name={componentName + "POID"}
                    floatingLabelText={"Purchase Order ID"}
                    hintText={"Purchase Order ID"}
                    fullWidth={true}
                    type="number" />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-4">
                <SelectInput
                    defaultValue={"0"}
                    name={componentName + "Vendor"}
                    fullWidth={true}
                    label={"Vendor"}
                    floatingLabelText={"Vendor"}
                    hintText={"Vendor"}
                    options={props.vendorOptions || []}
                />
            </div> {/* .col */}
        </div>
        <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-4">
                <SelectInput
                    defaultValue={"0"}
                    name={componentName + "RecordTypeSelect"}
                    fullWidth={true}
                    label={"Record Type"}
                    floatingLabelText={"Record Type"}
                    hintText={"Record Type"}
                    options={[
                        { text: "All", value: "0" },
                        { text: "Receives", value: "1" },
                        { text: "UnReceives", value: "2" }
                    ]}
                />
            </div> {/* .col */}
        </div>
        <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
        </div>
    </CardSimple>
);

export default Header;
